import { ReactComponent as BankIdLogo } from "../bankId/BankID_logo_white.svg";

const BankIdIcon = ({width}) => {
    return (<BankIdLogo width={width} />);
};

export default BankIdIcon;